"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearWishlistErrors = void 0;
var UseCaseError_1 = require("../../../../models/concrete/UseCaseError");
exports.clearWishlistErrors = [
    UseCaseError_1.UseCaseError.create('invalidData'),
    UseCaseError_1.UseCaseError.create('notFound'),
    UseCaseError_1.UseCaseError.create('problemInProcess')
];
//# sourceMappingURL=clearWishlistErrors.js.map